import { Button } from '@change-corgi/design-system-legacy/components/actions';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconNotificationsNone } from '@change-corgi/design-system-legacy/icons';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading, Text } from '@change-corgi/design-system-legacy/typography';

import { useDashboardReskinExperiment } from '../../../../../../hooks/useDashboardReskinExperiment';

import { useEmailDecisionMakerNotification } from './hooks/useEmailDecisionMakerNotification';
import { EmailDecisionMaker as EmailDecisionMakerReskin } from './index_new';

export function EmailDecisionMaker() {
	const {
		actions: { handleClick },
	} = useEmailDecisionMakerNotification();
	const {
		data: { isEnabled },
	} = useDashboardReskinExperiment();

	if (isEnabled) {
		return <EmailDecisionMakerReskin />;
	}

	return (
		<Flex
			data-qa="starter-can-email-dm-section-message"
			data-testid="starter-can-email-dm-section-message"
			p={24}
			sx={{ height: '100%', gap: 16 }}
		>
			<Icon icon={iconNotificationsNone} size={24} color="primary-white" />
			<Flex sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
				<Heading as="h2" size="h4">
					Contact Your Decision Maker
				</Heading>
				<Text as="p" mt={8}>
					Emailing decision makers makes it more likely that your petitions will be successful.
				</Text>
				<Button size="small" variant="secondary" onClick={handleClick} mt="16">
					Email your decision maker
				</Button>
			</Flex>
		</Flex>
	);
}
